import React from "react";
import { m } from "framer-motion";
import { useDispatch } from "react-redux";
import { twMerge } from "tailwind-merge";
import useSlot from "hooks/useSlot";
import GridSlotStatus from "./GridSlotStatus";
import { setSlotStatus, submitCode } from "store/game";
import SLOT_STATUS from "constants/slot-status";
import GridSlotItem from "../GridSlotItem.js";

export const gridSlotVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function GridSlot({ index = 0 }) {
  const dispatch = useDispatch();
  const [slot, requestNewItem] = useSlot(index);

  function handleSubmit(code) {
    dispatch(submitCode({ index, code }));
  }

  function handleTimeout() {
    dispatch(setSlotStatus({ index, status: SLOT_STATUS.TIMEOUT }));
  }

  return (
    <m.li variants={gridSlotVariants} className="relative">
      <GridSlotStatus onComplete={requestNewItem} status={slot.status} />

      <div
        className={twMerge(
          "transition-opacity duration-500 h-full bg-indigo-700 rounded relative",
          [SLOT_STATUS.EMPTY, SLOT_STATUS.ACTIVE].includes(slot.status)
            ? "opacity-100"
            : " opacity-0",
          slot.item?.type === "heading" && " bg-violet-700",
          slot.item?.type === "subheading" && "  bg-emerald-800"
        )}
      >
        <GridSlotItem
          key={slot?.item?.imageId}
          onSubmit={handleSubmit}
          onTimeout={handleTimeout}
          isDisabled={slot.status !== SLOT_STATUS.ACTIVE}
          item={slot.item}
        />
      </div>
    </m.li>
  );
}
